// Plan de marquage voyage (Welyft, v1 16/06/2026) — noms d'events GA4 tels que
// définis dans le tracking plan. Ne pas renommer : les triggers du container
// GTM-P6TNNF4 en dépendent.
//
// page_type / page_category : conformément aux autres funnels (loan `gtm_loan.*`,
// health), ces deux paramètres ne sont PAS poussés depuis le code — ils sont
// dérivés au niveau du container GTM. On ne pousse ici que les paramètres
// spécifiques à chaque event (insurer_name, offer_name, click_partner_link_url).
export const TravelTrackingEvents = {
    funnelAccess: 'voyage_funnel_access',
    submitTravelInfo: 'voyage_submit_travel_info',
    resultsView: 'voyage_results_view',
    offerDetailsView: 'voyage_offer_details_view',
    offerSelected: 'voyage_offer_selected',
    partnerLinkClicked: 'voyage_partner_link_clicked',
    contactDetailsView: 'voyage_contact_details_view',
    submitContactDetails: 'voyage_submit_contact_details',
    travelersInfoView: 'voyage_travelers_info_view',
    paymentView: 'voyage_payment_view',
    paymentStart: 'voyage_payment_start',
    paymentConfirm: 'voyage_payment_confirm',
} as const

// event_source du clic affilié — même convention que l'Auctor (`gtm_partner_link_clic`,
// cf. ResultButton.tsx) pour homogénéiser le suivi des redirections partenaires.
export const VOYAGE_AFFILIATE_EVENT_SOURCE = 'voyage_result_subscribe'
